import { BifrostBackendNestApi, BifrostBackendViaCdnApiV2 } from "../gateways/BifrostBackendApi.js";
import { getQueryParamValue } from "../libraries/utils.js";

const ABTestingProvider = {
	async getActiveTests(useApiCdnCaching) {
		const response = await (useApiCdnCaching ? BifrostBackendViaCdnApiV2 : BifrostBackendNestApi).get("ab-testing/active");
		return response.data;
	},
	async previewABTest(id) {
		const response = await BifrostBackendNestApi.get(`ab-testing/preview/${id}`);
		return response.data;
	},
	getABTests(useApiCdnCaching) {
		const id = getQueryParamValue("abTestId");
		return (id ? this.previewABTest(id) : this.getActiveTests(useApiCdnCaching));
	}
};

export default Object.freeze(ABTestingProvider);
